import { z } from 'zod';

import { ERROR_MESSAGES } from '../constants/sale.constants';

export const saleSetupSchema = z.object({
  price: z
    .number({
      required_error: ERROR_MESSAGES.REQUIRED_FIELD,
      invalid_type_error: ERROR_MESSAGES.REQUIRED_FIELD,
    })
    .positive('Стоимость должна быть больше 0')
    .min(1, 'Минимальная стоимость - 1 рубль'),
  freeChaptersCount: z
    .number({ required_error: ERROR_MESSAGES.REQUIRED_FIELD })
    .int('Количество глав должно быть целым числом')
    .min(1, 'Минимальное количество глав - 1')
    .max(100, 'Максимальное количество глав - 100'),
});

export type SaleSetupData = z.infer<typeof saleSetupSchema>;
